import { Observable, throwError } from 'rxjs';
import { Endpoints } from './endpoints';
import { catchError, map } from 'rxjs/operators';
import { BsError } from '../models/shared/bs-error';
import { ApiErrorLog } from '../models/shared/api-error-log';
import { Injectable } from '@angular/core';
import { BudBotConversation } from '../models/budbot/bud-bot-conversation';
import { BudBotUserQuery } from '../models/budbot/bud-bot-user-query';
import { Message } from '@mobilefirstdev/chat-interface';
import { Api } from './api';
import { TrackApiCall } from '../services/data-sync/track-api-call';

// Provided by logged in scope
@Injectable()
export class BudBotAPI extends Api {
  public serviceName = 'BudBot';

  @TrackApiCall()
  getConversations$(): Observable<BudBotConversation[]> {
    const url = Endpoints.getConversations();
    return this.apiClient.getArr$<BudBotConversation>(BudBotConversation, url).pipe(
      catchError(e => {
        const err = new BsError(e, this.serviceName);
        this.loggingService.LogAPIError(new ApiErrorLog(this.serviceName, 'GetConversations', err));
        return throwError(() => err);
      }),
      map(conversations => conversations || [])
    );
  }

  @TrackApiCall()
  getConversationMessages$(conversationId: string): Observable<Message[]> {
    const url = Endpoints.getConversationMessages(conversationId);
    return this.apiClient.getBudBotConversationMessages$(url).pipe(
      catchError(e => {
        const err = new BsError(e, this.serviceName);
        this.loggingService.LogAPIError(new ApiErrorLog(this.serviceName, 'GetConversationMessages', err));
        return throwError(() => err);
      })
    );
  }

  askBudBot$(msg: BudBotUserQuery): Observable<any> {
    const url = Endpoints.askBudBot();
    return this.apiClient.postObj$(BudBotUserQuery, url, msg).pipe(
      catchError(e => {
        const err = new BsError(e, this.serviceName);
        this.loggingService.LogAPIError(new ApiErrorLog(this.serviceName, 'AskBudBot', err));
        return throwError(() => err);
      })
    );
  }
}
